import * as React from "react";

const SvgCake = ({ color, size }) => (
  <svg
    viewBox="0 0 24 24"
    width={`${24 * (size || 1)}px`}
    height={`${24 * (size || 1)}px`}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15 4a1 1 0 0 1 .993.883L16 5v1a3 3 0 0 1 3 3v1a3 3 0 0 1 3 3v7a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1v-7a3 3 0 0 1 3-3V9a3 3 0 0 1 3-3V5a1 1 0 0 1 1.993-.117L10 5v1h1V5a1 1 0 0 1 1.993-.117L13 5v1h1V5a1 1 0 0 1 1-1ZM8.19 15.75l-.135.082A3.704 3.704 0 0 1 4 15.868V19h16v-3.135l-.145.091a3.704 3.704 0 0 1-3.72-.006l-.19-.118a1.704 1.704 0 0 0-1.755-.081l-.135.081a3.704 3.704 0 0 1-3.92.118l-.19-.118a1.704 1.704 0 0 0-1.755-.081ZM19 12H5a1 1 0 0 0-1 1l.001.684a3.7 3.7 0 0 1 .846.355l.208.129c.528.352 1.204.38 1.755.081l.135-.081a3.704 3.704 0 0 1 3.92-.118l.19.118c.528.352 1.204.38 1.755.081l.135-.081a3.704 3.704 0 0 1 3.92-.118l.19.118c.528.352 1.204.38 1.755.081l.135-.081c.327-.218.683-.38 1.055-.485V13a1 1 0 0 0-.883-.993L19 12Zm-3-4H8a1 1 0 0 0-1 1v1h10V9a1 1 0 0 0-.883-.993L16 8Z"
      fill={color}
      fillRule="nonzero"
    />
  </svg>
);

export default SvgCake;
